// ONUVEE Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ── Header scroll behaviour ──────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    });
  }

  // ── Scroll fade-up animations ────────────────────────
  const fadeEls = document.querySelectorAll('.fade-up');
  if (fadeEls.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => entry.target.classList.add('visible'), i * 80);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    fadeEls.forEach(el => observer.observe(el));
  }

  // ── Mobile nav ───────────────────────────────────────
  const toggle = document.querySelector('.site-header__mobile-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const overlay = document.querySelector('.mobile-nav__overlay');
  const closeBtn = document.querySelector('.mobile-nav__close');

  function openNav() {
    mobileNav && mobileNav.classList.add('open');
    overlay && overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    mobileNav && mobileNav.classList.remove('open');
    overlay && overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  toggle && toggle.addEventListener('click', openNav);
  closeBtn && closeBtn.addEventListener('click', closeNav);
  overlay && overlay.addEventListener('click', closeNav);

  // ── Email subscribe ──────────────────────────────────
  const subscribeForm = document.querySelector('.site-footer__subscribe-form');
  if (subscribeForm) {
    subscribeForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = this.querySelector('input');
      const btn = this.querySelector('button');
      if (input && input.value) {
        btn.textContent = 'Thank you';
        input.value = '';
        setTimeout(() => { btn.textContent = 'Subscribe'; }, 3000);
      }
    });
  }

});
